var map = {
	"./events-cat-cn.webp": 2000,
	"./events-cat.webp": 2001,
	"./games-cat.webp": 2002,
	"./live-casino-cat-cn.webp": 2003,
	"./live-casino-cat.webp": 2004,
	"./lottery-cat.webp": 2005,
	"./other-cat.webp": 2006,
	"./p2p-cat.webp": 2007,
	"./pd-table.webp": 2008,
	"./privacy-policy-title-bm.webp": 2009,
	"./privacy-policy-title-cn.webp": 2010,
	"./privacy-policy-title-id.webp": 2011,
	"./privacy-policy-title.webp": 2012,
	"./promos-1.webp": 2013,
	"./promos-2.webp": 2014,
	"./promos-3.webp": 2015,
	"./promos-4.webp": 2016,
	"./question.webp": 2017,
	"./sideBar-bg.webp": 2018,
	"./slot-cat-cn.webp": 2019,
	"./slot-cat.webp": 2020,
	"./special-cat-cn.webp": 2021,
	"./special-cat.webp": 2022,
	"./sports-cat-cn.webp": 2023,
	"./sports-cat.webp": 2024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 488;